import { render, staticRenderFns } from "./EditMateriePrima.vue?vue&type=template&id=c8925134&scoped=true"
import script from "./EditMateriePrima.vue?vue&type=script&lang=js"
export * from "./EditMateriePrima.vue?vue&type=script&lang=js"
import style0 from "./EditMateriePrima.vue?vue&type=style&index=0&id=c8925134&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8925134",
  null
  
)

export default component.exports